import { Stack, Typography } from '@mui/material';
import { Link } from '../../components/global/Link';
import { Frame } from '../../components/layouts/Frame';
import { useSearchParams } from 'react-router-dom';
import { UserCreditData } from '../../types';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useAPI } from '../../hooks/useAPI';

export const BuyCreditThankYou = () => {
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [searchParams] = useSearchParams();
  const userCreditId = searchParams.get('user-credit-id');
  const [useCredit, setUserCredit] = useState<UserCreditData | null>(null);

  useEffect(() => {
    if (isAuthenticated) {
      fetchData(`/user-credits/${userCreditId}`).then(({ errors, data }) => {
        setUserCredit(data);
      });
    }
  }, [userCreditId, isAuthenticated]);

  return (
    <Frame title="Buy Credits">
      <Stack padding={8} textAlign="center">
        <Typography
          variant="h5"
          fontWeight="600"
          color="#040505"
          lineHeight="200%">
          Thank you for your payment
          <br />
          {useCredit?.credit_count?.toLocaleString() ?? '{_}'} credits have been
          added to your account <br />
          Click here to go back to &nbsp;
          <Link to="/">
            <Typography
              variant="h5"
              fontWeight="600"
              display="inline"
              color="#EF4642">
              Dashboard
            </Typography>
          </Link>
          <br />
          Invoices will be emailed and can also be found &nbsp;
          <Link to="/invoices">
            <Typography
              variant="h5"
              fontWeight="600"
              display="inline"
              color="#EF4642">
              here
            </Typography>
          </Link>
        </Typography>
      </Stack>
    </Frame>
  );
};
